import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: 'signin-page.component.html'
})
export class SigninPageComponent {
  returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit() {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onSignin(): void {
    this.router.navigate([this.returnUrl]);
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/signin-page/signin-page.component.ts